export { default as seriesMap } from './seriesMap.vue';
export { default as scatterMap } from './scatterMap.vue';
export { default as hotMap } from './hotMap.vue';
export { default as lineMap } from './lineMap.vue';
export { default as timeMap } from './timeMap.vue';